import ManageStockTransactionForm from '@/PageComponents/StockTransaction/ManageStockTransactionForm';
import Breadcrumbs from '@/components/breadcrumbs';
import { FC } from 'react';
import * as Enums from '@/utils/enums';
import { useRouter } from 'next/router';
import { createFileRoute } from '@tanstack/react-router'

const CreateStockTransactionPage: FC = () => {

    const router = useRouter();
    const { type: typeParam, poid } = router.query as { type: string, poid?: string }; // TODO(tanstack-router): verify router.query → useParams/useSearch
    const type = typeParam ? parseInt(typeParam) : undefined;

    if (!type) return null;

    return (<>

        <div className="manage-container">

            <div className="row">
                <div className="title">
                    <Breadcrumbs currPage={{ text: `Create ${Enums.getEnumStringValue(Enums.StockTransactionType, type, true)}`, link: `/stocktransaction/create?type=${type}`, type: 'create' }} />
                </div>
            </div>

            <ManageStockTransactionForm
                isNew={true}
                stockTransactionType={type}
                purchaseOrderID={poid}
            />
        </div>

        <style jsx>{`
            
        `}</style>
    </>);
};

export default CreateStockTransactionPage;

export const Route = createFileRoute('/_authenticated/stocktransaction/create')({ component: CreateStockTransactionPage })
